import { Box } from '@mui/material';
import { Info } from '@sweep-io/sweep-design/dist/icons/Info';
import StyledTooltip from './StyledTooltip';

const InfoTooltip = ({ title }: { title: NonNullable<React.ReactNode> }) => (
  <StyledTooltip title={title}>
    <Box sx={{ margin: '0 6px', display: 'flex', alignContent: 'center' }}>
      <Info size="medium" />
    </Box>
  </StyledTooltip>
);

export { InfoTooltip };
